module.exports = __webpack_public_path__ + "static/Salesforce-Iphone-Still-d92ace7753ea14325f8bab737f6fa518.jpg";